export default "__VITE_ASSET__wpp9XL6Z__"